<template>
    <v-layout row>
        <v-flex>
            <v-text-field
                @keyup="search(vm)"
                v-model="searchMixin.searchText"
                prepend-inner-icon="fas fa-search"
                dense
                label="Zoek een Point of interest"
                solo>                    
            </v-text-field>         
            <v-data-table :headers="gridHeaders" :items="geoZones" hide-actions>
                <template slot="items" slot-scope="props">
                    <tr @click="selectGeozone(props.item)">
                        <td>{{props.item.name}}</td>
                        <td>{{type(props.item)}}</td>
                        <td>{{props.item.description}}</td>
                        <td>
                            <i style="cursor:pointer;"  class="far fa-map fa-2x" @click="openGeoZoneOnMap(props.item, $event)"></i>                            
                        </td>                        
                    </tr>
                </template>
            </v-data-table>       
            <v-pagination v-if="geoZonesMeta && geoZonesMeta.pagination && geoZonesMeta.pagination.count > 0"             
                v-model="geoZonesMeta.pagination.current_page"
                :length="geoZonesMeta.pagination.total_pages"                           
                @input="loadPage">
            </v-pagination>                 
        </v-flex>
        <v-flex v-if="selectedGeoZoneMap">
            <dd-geo-zone-map @close="selectedGeoZoneMap=null" :geoZone="selectedGeoZoneMap"></dd-geo-zone-map>
        </v-flex>        
    </v-layout>
</template>

<script>
    import * as types from "../../store/types"
    import { mapGetters } from 'vuex'
    import searchMixin from "../../plugins/mixins/SearchWithPagerMixin"
    import DdGeoZoneMap from "../../components/global/DdGeoZoneMap"
    

    export default {
       mixins:[searchMixin],
       components:{
         DdGeoZoneMap
       },
       data() {
            return {
                selectedGeoZoneMap:null,
                itemSelected:null,
                gridHeaders: [
                    { text: "Naam", sortable: false },
                    { text: "Type", sortable: false },
                    { text: "Omschrijving", sortable: false },                                        
                    { text: "Kaart", sortable: false },  
                ],                       
            }
       }, 
       computed: {
          ...mapGetters({
              geoZones: types.GEO_ZONES,
              geoZonesMeta: types.GEO_ZONES_META
          }),                 
       },
       methods: {
           type(zone){
               return (zone.geoZoneType) ? zone.geoZoneType.name : ""
           },
           selectGeozone(zone){
               this.itemSelected = zone
               this.$emit("itemSelected",zone)
           },
           openGeoZoneOnMap(zone,e){                              
               this.$emit("showGeoZoneOnMap", zone)
               this.selectedGeoZoneMap = zone               
               e.stopPropagation();
           }
       },
       mounted(){
            // configure mixin
            this.searchMixin.perPage              = 5
            this.searchMixin.payloadIncludes      = "geoZoneType, geoZoneEvent, geoZoneEvent.enterEvent, geoZoneEvent.exitEvent"
            this.searchMixin.searchStore          = types.SEARCH_GEO_ZONES
            this.searchMixin.defaultStore         = types.GEO_ZONES                    
            this.reset();
       }
    }
</script> 

<style scoped>

</style>